export const PROMPT_LOCATION_KEY = 'purfurryUserLocation';

export const promptUserLocation = (onSuccess) => {
  if (typeof window === 'undefined' || !navigator.geolocation) {
    return;
  }

  // Check if we already have it
  const existing = sessionStorage.getItem(PROMPT_LOCATION_KEY);
  if (existing) {
    try {
      const parsed = JSON.parse(existing);
      if (parsed.origin) {
        if (onSuccess) onSuccess(parsed);
        return;
      }
      if (parsed.denied) {
        return; // already denied this session
      }
    } catch (e) {
      // ignore
    }
  }

  sessionStorage.setItem(PROMPT_LOCATION_KEY, JSON.stringify({ loading: true }));

  navigator.geolocation.getCurrentPosition(
    async (position) => {
      const lat = position.coords.latitude;
      const lng = position.coords.longitude;
      
      try {
        const res = await fetch(
          `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?types=place,locality&access_token=${process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}`
        );
        const data = await res.json();
        
        let address = "Current Location";
        let boundsString = null;
        let cityName = null;
        
        if (data.features && data.features.length > 0) {
          const feature = data.features[0];
          address = feature.place_name || "Current Location";
          
          if (feature.bbox) {
            // Mapbox bbox is [minLng, minLat, maxLng, maxLat] which corresponds to [swLng, swLat, neLng, neLat]
            // We need "neLat,neLng,swLat,swLng"
            const [swLng, swLat, neLng, neLat] = feature.bbox;
            boundsString = `${neLat},${neLng},${swLat},${swLng}`;
          } else {
            // Approximation if bbox is missing
            const offset = 0.05;
            boundsString = `${lat + offset},${lng + offset},${lat - offset},${lng - offset}`;
          }

          // Try to extract city name from features
          const placeFeature = data.features.find(f => f.place_type && f.place_type.includes('place'));
          if (placeFeature && placeFeature.text) {
            cityName = placeFeature.text;
          }
        } else {
          // Approximation
          const offset = 0.05;
          boundsString = `${lat + offset},${lng + offset},${lat - offset},${lng - offset}`;
        }

        const locationData = {
          address,
          origin: { lat, lng },
          bounds: boundsString,
          isCurrentLocation: true,
          cityName
        };
        
        sessionStorage.setItem(PROMPT_LOCATION_KEY, JSON.stringify(locationData));
        if (onSuccess) onSuccess(locationData);
        
      } catch (err) {
        console.error("Error geocoding current location", err);
        sessionStorage.removeItem(PROMPT_LOCATION_KEY);
      }
    },
    (error) => {
      console.warn("User denied or geolocation failed", error);
      sessionStorage.setItem(PROMPT_LOCATION_KEY, JSON.stringify({ denied: true }));
    }
  );
};
